import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/Home";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/Home",
    name: "Home2",
    component: Home
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../components/AboutUs")
  },
  {
    path: "/donate",
    name: "donate",
    component: () => import("../components/DonateView")
  },
  {
    path: "/toronto",
    name: "toronto",
    component: () => import("../components/Leicester")
  },
  {
    path: "/montreal-resources",
    name: "montreal-resources",
    component: () => import("../components/CoventryResources")
  },
  {
    path: "/montreal-addresses",
    name: "montreal-addresses",
    component: () => import("../components/CoventryAddress")
  },
  {
    path: "/montreal-alerts",
    name: "montreal-alerts",
    component: () => import("../components/CoventryAlerts")
  },
  {
    path: "/montreal-events",
    name: "montreal-events",
    component: () => import("../components/CoventryEvent")
  },
  {
    path: "/montreal-people",
    name: "montreal-people",
    component: () => import("../components/CoventryPerson")
  },
  {
    path: "/toronto-resources",
    name: "toronto-resources",
    component: () => import("../components/LeicesterResources")
  },
  {
    path: "/toronto-addresses",
    name: "toronto-addresses",
    component: () => import("../components/LeicesterAddress")
  },
  {
    path: "/toronto-people",
    name: "toronto-people",
    component: () => import("../components/LeicesterPerson")
  },
  {
    path: "/toronto-alerts",
    name: "toronto-alerts",
    component: () => import("../components/LeicesterAlerts")
  },
  {
    path: "/toronto-events",
    name: "toronto-events",
    component: () => import("../components/LeicesterEvent")
  },
  {
    path: "/donation-admin",
    name: "donation-admin",
    component: () => import("../components/DonationAdmin")
  },
  {
    path: "/shop-products",
    name: "shop-products",
    component: () => import("../components/ShopProducts")
  },
  {
    path: "/shop-products-admin",
    name: "shop-products-admin",
    component: () => import("../components/ShopProductsAdmin")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
